import APIClient from './client'
import { camelizeKeys } from 'humps'

const getAllFbPages = () => {
  return APIClient().get('/v1/fb_pages')
    .then( response => camelizeKeys(response.data))
}

const findFbPage = (fbPageServiceId, fbBmSystemUserId) => {
  return APIClient().get('/v1/find_fb_page', {
    params: {
      fb_page_service_id: fbPageServiceId,
      fb_bm_system_user_id: fbBmSystemUserId
    }
  })
    .then( response => camelizeKeys(response.data))
}

const fbPagesAPI = {
  getAllFbPages,
  findFbPage
}

export default fbPagesAPI
